// AUTO-GENERATED by scripts/generate-version.mjs - do not edit manually.
export const GAME_VERSION = '1.3.5';
export const GAME_BUILD_HASH = '98204a9';
